/**
 * Utility functions for handling addresses
 */

/**
 * Interface representing an address.
 */
export interface Address {
  /** Street address of the location. */
  street_address: string
  /** Additional information about the address, such as apartment number. */
  complement: string
  /** City where the address is located. */
  city: string
  /** State where the address is located. */
  state: string
}

/**
 * Searches for an address by its CEP (Postal Code).
 * @param cep CEP (Postal Code) to search for the address.
 * @returns {Promise<Address>} Promise resolving to the address information.
 */
export async function searchAddressByCEP(cep: string): Promise<Address> {
  const cepLimpo = cep.replaceAll(/\D/g, '')
  const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`)
  const data = await response.json()

  if (data.erro) throw new Error('CEP not found')

  return {
    street_address: data.logradouro,
    complement: data.complemento,
    city: data.localidade,
    state: data.uf
  }
}
